<script setup lang="ts">
import { MapViewport } from '@/constants/ui/map/mapConstants'
import { defineProps } from 'vue'
import {
  RESIDENTIAL_DAMAGE_LABELS,
  EMERGENCY_LABELS,
  AI_COLLAPSE_LABELS
} from '@/constants/ui/map/legendConstants'
import { useGovernmentSettingStore } from '@/stores/governmentSettingStore'

const { includesFeatureOptionsEmergency } = useGovernmentSettingStore()

const props = defineProps<{
  /** 地図の表示領域 */
  mapViewport: MapViewport
}>()
</script>

<template>
  <!-- 広域・中域表示の場合 -->
  <div v-if="props.mapViewport === MapViewport.WIDE || props.mapViewport === MapViewport.MIDDLE">
    <div class="heatmap-legend">
      <div class="gradient-bar">
        <span class="label top-label">多</span>
        <span class="label bottom-label">少</span>
      </div>
    </div>
  </div>
  <!-- 狭域表示の場合 -->
  <div v-else-if="props.mapViewport === MapViewport.NARROW">
    <div class="building-marker-legend">
      <div class="building-marker-legend-title">凡例</div>

      <div class="mb-3">
        <div class="building-marker-legend-subtitle">住家被害認定調査</div>
        <div
          v-for="item in RESIDENTIAL_DAMAGE_LABELS"
          :key="item.label"
          class="category-flex-container"
        >
          <img :src="item.icon" class="icon" />
          <span>{{ item.label }}</span>
        </div>
      </div>

      <div class="mb-3" v-if="includesFeatureOptionsEmergency()">
        <div class="building-marker-legend-subtitle">応急危険度判定</div>
        <div v-for="item in EMERGENCY_LABELS" :key="item.label" class="category-flex-container">
          <img :src="item.icon" class="icon" />
          <span>{{ item.label }}</span>
        </div>
      </div>

      <div>
        <div class="building-marker-legend-subtitle">AI倒壊判定</div>
        <div v-for="item in AI_COLLAPSE_LABELS" :key="item.label" class="category-flex-container">
          <img :src="item.icon" class="icon" />
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.heatmap-legend {
  width: 30px;
  height: 120px;
  user-select: none;
  position: relative;
  font-weight: bold;
  font-size: 14px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* グラデーションバー */
.gradient-bar {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #5dc4b1, #a7d676, #babe66, #b99174, #ad3d83);
}

/* ラベル共通 */
.label {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  writing-mode: vertical-rl;
  user-select: none;
  font-weight: bold;
  color: white;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.7);
  pointer-events: none;
}

.top-label {
  top: 10px;
  color: black;
}

.bottom-label {
  bottom: 10px;
  color: black;
}

.building-marker-legend {
  background: #f9f9f9;
  padding: 8px;
}

.building-marker-legend-title {
  font-size: 18px;
  font-weight: bold;
}

.building-marker-legend-subtitle {
  font-size: 16px;
  margin-left: 0.5rem;
}

.category-flex-container {
  font-size: 14px;
  margin-left: 1rem;
  display: flex;
  align-items: center;
}

.icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin: 0 0.5rem 0 0.3rem;
}
</style>
